import { Outlet } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import { ShellBar } from "./ShellBar";
import { AppSidebar } from "./AppSidebar";
import { useShellBreadcrumbs } from "./useShellBreadcrumbs";

export function AppLayout() {
  const breadcrumbs = useShellBreadcrumbs();
  return (
    <SidebarProvider>
      <div className="h-screen flex flex-col w-full overflow-hidden">
        <ShellBar breadcrumbs={breadcrumbs} />
        <div className="flex flex-1 w-full overflow-hidden">
          <AppSidebar />
          <main className="flex-1 overflow-auto p-6 bg-background">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
